import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/assessment/[token]/AssessmentClient.tsx");
